var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-gesture-container",on:{"touchstart":_vm.start,"touchmove":_vm.move,"touchend":_vm.end}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }